function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-coins",
  "data-name": "Icon awesome-coins",
  d: "M0,15.04v1.585C0,17.935,3.191,19,7.125,19s7.125-1.065,7.125-2.375V15.04c-1.533,1.08-4.334,1.585-7.125,1.585S1.533,16.12,0,15.04ZM11.875,4.75C15.809,4.75,19,3.685,19,2.375S15.809,0,11.875,0,4.75,1.065,4.75,2.375,7.941,4.75,11.875,4.75ZM0,11.148v1.915c0,1.31,3.191,2.375,7.125,2.375s7.125-1.065,7.125-2.375V11.148c-1.533,1.262-4.338,1.915-7.125,1.915S1.533,12.409,0,11.148Zm15.438.408C17.564,11.144,19,10.379,19,9.5V7.915A9.113,9.113,0,0,1,15.438,9.2ZM7.125,5.938C3.191,5.938,0,7.266,0,8.906s3.191,2.969,7.125,2.969,7.125-1.329,7.125-2.969S11.059,5.938,7.125,5.938Zm8.138,2.089C17.49,7.626,19,6.839,19,5.938V4.353A12.081,12.081,0,0,1,13.037,5.9,4.156,4.156,0,0,1,15.263,8.027Z",
  fill: "#2f455c"
});

var SvgCoins = function SvgCoins(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coins.5c5a57fa.svg";
export { ForwardRef as ReactComponent };